import React, { useState } from 'react';
import numeral from 'numeral';
// material
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import CloudIcon from '@material-ui/icons/CloudDownload';
// components
import { Address } from '../../../entities/home';

interface PropertyProps {
  address: Address;
}

const Property: React.FC<PropertyProps> = (props) => {

  const classes = useStyles();

  return (
    <div className={classes.addressContainer}>
      <div className={classes.addressRow}>
        <div className={classes.addressProp}>Beds:</div>
        <div className={classes.addressValue}>{props.address.beds}</div>
      </div>
      <div className={classes.addressRow}>
        <div className={classes.addressProp}>Baths:</div>
        <div className={classes.addressValue}>{props.address.baths}</div>
      </div>
      <div className={classes.addressRow}>
        <div className={classes.addressProp}>Sqft:</div>
        <div className={classes.addressValue}>{props.address.sqft}</div>
      </div>
      <div className={classes.addressRow}>
        <div className={classes.addressProp}>Estimated Value:</div>
        <div className={classes.addressValue}>{numeral(props.address.estimate).format('$0.0')}</div>
      </div>
      <div className={classes.addressRow}>
        <div className={classes.addressProp}>Estimated Loan Balance:</div>
        <div className={classes.addressValue}>{numeral(props.address.loanBalance).format('$0.0')}</div>
      </div>
      <div className={classes.addressRow}>
        <div className={classes.addressProp}>Loan Amount:</div>
        <div className={classes.addressValue}>{numeral(props.address.loanAmount).format('$0.0')}</div>
      </div>
      <div className={classes.addressRow}>
        <div className={classes.addressProp}>Loan Date:</div>
        <div className={classes.addressValue}>{props.address.loanDate}</div>
      </div>
      <div className={classes.addressRow}>
        <div className={classes.addressProp}>Loan Type:</div>
        <div className={classes.addressValue}>{props.address.loanType}</div>
      </div>
      <div className={classes.addressRow}>
        <div className={classes.addressProp}>Sale Date:</div>
        <div className={classes.addressValue}>{props.address.saleDate}</div>
      </div>
      <div className={classes.addressRow}>
        <div className={classes.addressProp}>Sale Price:</div>
        <div className={classes.addressValue}>{numeral(props.address.salePrice).format('$0.0')}</div>
      </div>
      <div className={classes.addressRow}>
        <div className={classes.addressProp}>Tax Amount:</div>
        <div className={classes.addressValue}>{numeral(props.address.taxAmount).format('$0.0')}</div>
      </div>
      <div className={classes.addressRow}>
        <div className={classes.addressProp}>Tax Value:</div>
        <div className={classes.addressValue}>{numeral(props.address.taxValue).format('$0.0')}</div>
      </div>
    </div>
  );

}

export default Property;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    addressContainer: {
      padding: 20,
      backgroundColor: '#F4F7FC'
    },
    addressRow: {
      display: 'flex',
      paddingBottom: 5
    },
    addressProp: {
      paddingRight: 10,
      width: '60%',
      textAlign: 'left',
      color: '#9db0be'
    },
    addressValue: {
      fontWeight: 'bold',
      width: '40%',
      textAlign: 'right'
    }
  })
);


// WEBPACK FOOTER //
// ./src/pages/campaign/components/Property.tsx